import {ApiProperty} from "@nestjs/swagger";

export class RequestById{
    @ApiProperty()
    requestId: number;

}